import {Component, OnInit} from '@angular/core';
import {IYii} from '../../../globals';
import {DynamicDialogRef} from 'primeng/dynamicdialog';
import {Button} from 'primeng/button';
import {MessageService} from 'primeng/api';
import {FormsModule} from '@angular/forms';
import {Message} from 'primeng/message';
import {InputText} from 'primeng/inputtext';
import {FormService} from '../services/FormService';

declare var Yii: IYii;

@Component({
  template: `
<div style="display: flex; gap: 1rem;margin: 1rem 0;align-items: center;">
  <label>New Name</label>
  <input type="text" [(ngModel)]="newName" pInputText style="flex-grow: 1;"/>
</div>

@if(errorMessage) {
  <p-message severity="error" [text]="errorMessage"></p-message>
}

<div style="display: flex; gap: 1rem;justify-content: flex-end;">
  <p-button label="Duplicate" (onClick)="duplicateForm()"></p-button>
  <p-button severity="secondary" label="Cancel" (onClick)="close()"></p-button>
</div>
  `,
  imports: [
    Button,
    FormsModule,
    Message,
    InputText
  ]
})
export class DuplocateFormDialog implements OnInit {

  newName: string = ""
  errorMessage: string = ""

  constructor(
    private ref: DynamicDialogRef,
    private toast: MessageService,
    public fsvc: FormService,
  ) {
  }

  ngOnInit(): void {
    this.newName = this.fsvc.form_json.form_name + " NEW";
  }

  close() {
    this.ref.close();
  }

  duplicateForm() {
    if (this.newName.trim() == "") {
      this.errorMessage = Yii.t('app', 'Name can not be blank');
    } else {
      // const oldFormName = this.fsvc.form_json.form_name;
      // this.fsvc.form_json.form_name = this.newName.trim();
      // const formBuilderResource = new this.fbr.Form(this.fsvc.form_json);
      // formBuilderResource.$save(
      //   {id: ''},
      //   (response: any) => {
      //     if (response.status === true) {
      //       const successMessage = Yii.t('app', 'Form was successfully duplicated');
      //       this.toast.add({severity: 'success', summary: successMessage});
      //       this.close();
      //     } else {
      //       this.errorMessage = Yii.t('app', 'Error while duplicating form');
      //     }
      //     this.fsvc.form_json.form_name = oldFormName;
      //   }
      // );
    }
  }

}
